const state = {
    user:null,
};

const getters = {
    user: state => state.user,
};

const actions = {
    getUser({commit, state}){
        axios.get('/api/admin/user').then((response) => {
            commit('setUser', response.data.data);
        })
    }
};

const mutations = {
    setUser(state, user){
        state.user = user;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}